import { useEffect, useState } from "react";
import { ENABLE_MSW_PANEL } from "../../config/msw";
import {
	getGlobalMockMode,
	setGlobalMockMode,
} from "../../mocks/storage/login-mock-mode";
import { MockMode } from "../../mocks/types";
import "./mock-panel.scss";

const modeLabels: Record<MockMode, string> = {
	success: "Success",
	unauthorized: "401",
	serverError: "500",
	networkError: "Network",
};

const modes: MockMode[] = [
	"success",
	"unauthorized",
	"serverError",
	"networkError",
];

export const MockPanel = () => {
	const [mode, setMode] = useState<MockMode>(getGlobalMockMode());

	useEffect(() => {
		setGlobalMockMode(mode);
	}, [mode]);

	if (!ENABLE_MSW_PANEL) {
		return null;
	}

	return (
		<div className="mock-panel">
			<p className="mock-panel__title">Mock API mode</p>
			<div className="mock-panel__modes">
				{modes.map((item) => (
					<label key={item} className="mock-panel__mode">
						<input
							type="radio"
							name="mock-mode"
							checked={mode === item}
							onChange={() => setMode(item)}
						/>
						<span>{modeLabels[item]}</span>
					</label>
				))}
			</div>
		</div>
	);
};

